import request from '@/utils/request'

export function add(disease) {
  return request({
    url: '/InfoSymptom/addData',
    method: 'post',
    data: disease
  })
}

export function edit(disease) {
  return request({
    url: '/InfoSymptom/editData',
    method: 'post',
    data: disease
  })
}

export function getById(id) {
  return request({
    url: `/InfoSymptom/getById/${id}`,
    method: 'post'
  })
}
